import { render, staticRenderFns } from "./NotificationsPopover.vue?vue&type=template&id=9e720696&scoped=true&"
import script from "./NotificationsPopover.vue?vue&type=script&lang=js&"
export * from "./NotificationsPopover.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsPopover.vue?vue&type=style&index=0&id=9e720696&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e720696",
  null
  
)

export default component.exports